import { initializeApp } from 'firebase/app'
// NOTIFICAÇÕES DESATIVADAS - import { getMessaging, getToken, onMessage } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: 'AIzaSyCn99W_vuJFs4vCDxa92pGp1GYdxS4VjvM',
  authDomain: 'caixa-mestre.firebaseapp.com',
  projectId: 'caixa-mestre',
  storageBucket: 'caixa-mestre.firebasestorage.app',
  messagingSenderId: '781263463760',
  appId: '1:781263463760:web:dbf3c2f46082b0fc1f3855'
}

// NOTIFICAÇÕES DESATIVADAS
// const VAPID_KEY = 'BDKA-ZhSikHaq9sjf2160qTETq6UIQFQNlLCgUs9K3IQ1ngbezSUQjw7iKiWJ21qHP54MrJ_9pwtpdCcSdGNfA4'

const app = initializeApp(firebaseConfig)
// NOTIFICAÇÕES DESATIVADAS - const messaging = getMessaging(app)

// NOTIFICAÇÕES DESATIVADAS
export async function getFcmToken() {
  return null
}

export function onFcmMessage(callback) {
  return () => {}
}

export const messaging = null
